import defaultImg from "../assets/default.png";

const BUCKET = "bioindex-prototype.firebasestorage.app";
const STORAGE_BASE = `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/`;

export function iconUrl(filename) {
  if (!filename) return defaultImg;
  return `${STORAGE_BASE}icons%2F${encodeURIComponent(filename)}?alt=media`;
}

export { defaultImg };
